import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Item } from '../../model/item';
import { Answer } from '../../model/answer';
import { Observable, Subject, asapScheduler, pipe, of, from, interval, merge, fromEvent } from 'rxjs';
import { CONFIG } from '../../constants/constants';
import { Token } from "../../model/token";


/*Servicio para el manejo de tokens*/
@Injectable({
  providedIn: 'root'
})
export class TokenService{

    //Objeto para acceso a la base de datos indexedDB
    private dataBase:any = null;

    //constructor de la clase
    constructor(private http: HttpClient){
       this.initDb();
	}


  /*Se encarga de abrir conexion con indexedDB*/
  public initDb(){
    let self = this;
    this.dataBase = indexedDB.open(CONFIG.DB_NAME);
    this.dataBase.onupgradeneeded = function(event:any) { }
    this.dataBase.onsuccess = function(event:any){ }
    this.dataBase.onerror = function(event:any){
      console.log('...error opening dataBase...');
    }
  }

  /*Se encarga de consultar el token del store en indexedDB*/
  public getToken(tokenId:string):Promise<Token>{
     let self = this;
     return new Promise(resolve =>{
        self.dataBase = indexedDB.open(CONFIG.DB_NAME);
        self.dataBase.onupgradeneeded = function(event:any) { }
        self.dataBase.onsuccess = function(event:any){
            let connection = self.dataBase.result;
            let transaction = connection.transaction([CONFIG.TOKEN_STORE],'readonly');
            let objStore = transaction.objectStore(CONFIG.TOKEN_STORE);
            let request = objStore.get(tokenId);
            request.onsuccess = function(event:any){
                resolve(request.result as Token);
            }
            request.onerror = function(event:any){
             console.log('...Error obteniendo item '+tokenId+'...');
            }
        }
        self.dataBase.onerror = function(event:any){
            console.log('...error opening dataBase...');
        }
        });
     }
}
